<template>
    <div>
        <div style="height: 2px !important">
            <v-progress-linear :indeterminate="loading" :color="loading ? 'primary' : 'grey lighten-2'" :value="!loading ? 100 : 0"></v-progress-linear>
        </div>
        <v-row dense class="px-0 pt-0 secondary">
            <v-col cols="4" class="px-8 py-8">
                <div class="text-h5 font-weight-light white--text">
                    Organisation: <strong>{{ MIX_findOrganisationName(GET_currentUserProfile.orgId) }}</strong>
                </div>
            </v-col>
        </v-row>
        <v-row dense class="px-5 pt-2">
            <v-col cols="12" class="d-flex align-center justify-end">
                <!-- Search -->
                <SearchField label="Search" v-model="search" :dense="true" />
                <AppButton @click.native="previous()" :disabled="tableOptions.page === 1">
                    <v-icon class="primary--text">icons8-previous</v-icon>
                </AppButton>
                <AppButton v-if="!table" @click.native="table = true">
                    <v-icon class="primary--text">icons8-table</v-icon>
                </AppButton>
                <AppButton v-if="table" @click.native="table = false">
                    <v-icon class="primary--text">icons8-rows</v-icon>
                </AppButton>
                <AppButton @click.native="next()" :disabled="tableOptions.page * tableOptions.itemsPerPage >= itemsTotal">
                    <v-icon class="primary--text">icons8-next</v-icon>
                </AppButton>
                <AppButton @click.native="getTableData">
                    <v-icon>icons8-synchronize</v-icon>
                </AppButton>
            </v-col>
        </v-row>
        <v-row dense class="px-5">
            <div class="d-flex align-center px-2 my-2" style="width: 100% !important">
                <div class="body-2 grey--text text--darken-2">
                    <!-- CHANGED: use displayFrom/displayTo and handle 0 gracefully -->
                    Showing <strong>{{ displayFrom }}</strong>
                    <span v-if="itemsTotal !== 0 && itemsTo !== itemsTotal">
                        to <strong>{{ displayTo }}</strong>
                    </span>
                    of <strong>{{ itemsTotal }}</strong>
                </div>
            </div>
            <!-- Table -->
            <v-col cols="12" class="pt-2">
                <!-- Data Table -->
                <DataTable
                    v-if="table"
                    :actions="['View']"
                    :tableheaders="tableHeaders"
                    :loading="loading"
                    custom="organisation"
                    :tabledata="tableData"
                    :datatableoptions="tableOptions"
                    :itemstotal="itemsTotal"
                    v-on:view="viewSite"
                    v-on:tableoptions="updateTableOptions"
                />
                <!-- Card View -->
                <v-row v-if="!table">
                    <v-col
                        cols="12"
                        xs="12"
                        sm="4"
                        md="4"
                        lg="4"
                        v-for="item in tableData"
                        :key="item.entityId"
                        @click="$router.push('/site-dashboard/' + item.entityId)"
                    >
                        <BasicCard footerclass="grey lighten-4" class="" style="min-height: 230px !important">
                            <template v-slot:header>
                                <div class="full-width d-flex align-start px-4 pt-2" style="height: 60px !important; overflow: hidden !important">
                                    <div class="text-body-1 font-weight-bold primary--text text-left">
                                        {{ item.siteName.substring(0, 80) }}
                                    </div>
                                    <v-spacer />
                                </div>
                            </template>
                            <div class="mt-2 mb-1 grey lighten-3" style="height: 3px !important"></div>
                            <div class="px-4 text-body-1 grey--text text--darken-4 pb-5 mt-3">
                                <div class="mt-2 d-flex align-center">
                                    <div class="text-body-2 font-italic">{{ item.sourceName }}</div>
                                    <v-spacer />
                                    <div class="text-body-2">{{ item.type }}</div>
                                </div>
                                <div class="mt-1">{{ item.town }}</div>
                                <div class="mt-1">{{ item.postcode }}</div>
                            </div>
                        </BasicCard>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'SitesAdmin',
    data: () => ({
        loading: false,
        table: true,
        maxFetch: 100,
        search: '',
        tableData: [],
        itemsTotal: 0,
        tableHeaders: [
            { text: 'Site Name', value: 'siteName', align: 'start', sortable: false },
            { text: 'Address Line 1', value: 'addressLine1', align: 'start', sortable: false },
            { text: 'Address Line 2', value: 'addressLine2', align: 'start', sortable: false },
            { text: 'Town', value: 'town', align: 'start', sortable: false },
            { text: 'County', value: 'county', align: 'start', sortable: false },
            { text: 'Postcode', value: 'postcode', align: 'start', sortable: false },
            { text: '', value: 'action', align: 'center', sortable: false, width: '150px' }
        ],
        tableOptions: {
            page: 1,
            itemsPerPage: 10,
            sortBy: ['siteName'],
            sortDesc: [true],
            groupBy: [],
            groupDesc: [],
            mustSort: false,
            multiSort: false
        }
    }),
    computed: {
        ...mapGetters({
            GET_currentUserProfile: 'GET_currentUserProfile'
        }),
        filterQuery() {
            let query = '@deleted:{false}'
            if (this.search && this.search.length > 1) {
                query = `${this.search}* ${query}`
            }
            return query
        },
        itemsFrom() {
            return (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage
        },
        itemsTo() {
            if (this.tableOptions.page * this.tableOptions.itemsPerPage > this.itemsTotal) {
                return this.itemsTotal
            } else {
                return this.tableOptions.page * this.tableOptions.itemsPerPage
            }
        },
        // NEW: safe display numbers for 0 or 1
        displayFrom() {
            return this.itemsTotal === 0 ? 0 : this.itemsFrom + 1
        },
        displayTo() {
            return this.itemsTotal === 0 ? 0 : this.itemsTo
        },
        itemsCount() {
            return this.tableOptions.itemsPerPage
        },
        itemsSortBy() {
            let sortBy = this.tableOptions.sortBy
            if (sortBy.length > 0) {
                sortBy = sortBy.join(',')
            }
            return sortBy
        },
        itemsSortDesc() {
            return this.tableOptions.sortDesc[0] ? 'DESC' : 'ASC'
        }
    },
    watch: {
        filterQuery: {
            handler() {
                this.tableOptions.page = 1
                this.getTableData()
            },
            deep: true
        },
        tableOptions: {
            handler() {
                this.getTableData()
            },
            deep: true
        }
    },
    methods: {
       async getTableData() {
            try {
                this.loading = true
                const filterQuery = this.filterQuery + ` @orgId:{${this.GET_currentUserProfile.orgId}}`

                let dataResult = await this.REDIS_searchFor(
                    'site',
                    0,
                    this.maxFetch,
                    this.itemsSortBy,
                    this.itemsSortDesc,
                    filterQuery
                )

                // CHANGED: guard against missing arrays
                const userSiteIds = (this.GET_currentUserProfile && this.GET_currentUserProfile.siteIds) || []
                const documents = (dataResult && dataResult.data && dataResult.data.documents) || []

                // filter by user siteIds
                const filtered = documents.filter((item) =>
                    userSiteIds.includes(item.entityId)
                )

                // CHANGED: set totals, clamp page, then slice safely
                this.itemsTotal = filtered.length
                const totalPages = this.itemsTotal === 0
                  ? 1
                  : Math.ceil(this.itemsTotal / this.tableOptions.itemsPerPage)

                if (this.tableOptions.page > totalPages) {
                    this.tableOptions.page = totalPages
                }
                if (this.tableOptions.page < 1) {
                    this.tableOptions.page = 1
                }

                const start = (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage
                const end = Math.min(start + this.tableOptions.itemsPerPage, this.itemsTotal)
                this.tableData = filtered.slice(start, end)

                this.loading = false
            } catch (error) {
                console.error(error)
                this.loading = false
            }
       },
        updateTableOptions(options) {
            this.tableOptions = options
        },
        viewSite(item) {
            this.$router.push('/site-dashboard/' + item.entityId)
        },
        next() {
            if (this.tableOptions.page * this.tableOptions.itemsPerPage < this.itemsTotal) {
                this.tableOptions.page++
            }
        },
        previous() {
            if (this.tableOptions.page > 1) {
                this.tableOptions.page--
            }
        }
    },
    created() {
        this.MIX_getOrganisations()
        this.getTableData()
    }
}
</script>

<style scoped>
.d-flex {
    gap: 15px;
}
</style>
